<template>
  <div>
    <h5 class="font-semibold mb-16">{{ title }}</h5>
    <div ref="collapseList" class="collapse-list overflow-hidden" :style="{ 'max-height': expand ? 'initial' : `${LIST_MAX_HEIGHT}px` }">
      <slot name="content"></slot>
    </div>
    <footer>
      <button v-if="isExpandable" class="btn btn-sm text-blue text-sm underline pl-0" @click="toggleCollapse">
        <span v-show="!expand">{{ $t('expandContent') }} ({{ totalAmount }})</span>
        <span v-show="expand">{{ $t('collapseContent') }}</span>
      </button>
    </footer>
  </div>
</template>

<script>
const LIST_MAX_HEIGHT = 184

export default {
  name: 'collapseCheckboxList',
  props: {
    title: {
      type: String,
      default: ''
    },
    totalAmount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      LIST_MAX_HEIGHT,
      isExpandable: false,
      expand: true
    }
  },
  mounted () {
    this.setExpandable()
  },
  watch: {
    totalAmount () {
      this.expand = true
      this.$nextTick(() => {
        this.setExpandable()
      })
    }
  },
  methods: {
    setExpandable () {
      this.isExpandable = (this.$refs.collapseList.clientHeight > LIST_MAX_HEIGHT)
      this.expand = false
    },
    toggleCollapse () {
      this.expand = !this.expand
    }
  }
}
</script>
